<!-- conversationBg -->
<div class="conversationBg" [ngClass]="{'chatActive': showTextQuestionControl()}">

  <div class="fixed_head">
    <div class="coursename-top d-flex justify-content-center align-items-center">
      <h5>{{course.courseName}}</h5>
    </div>
    <!-- in-playTop -->
    <div class="in-playTop d-flex justify-content-end">
      @if(this.playedHoles.length <= 0){ <div class="btn shadow-none pe-none border-0 bg-transparent">
      </div>
    }
    @if (this.playedHoles.length > 0) {
      <button class="btn" type="button" (click)="prevHole()">
        {{getHoleNumber('holeNumber', this.playedHoles[0].hole.HoleNumber)}}
      </button>
    }
    <button class="btn bg-black text-white" (click)="endRound()">
      End
    </button>
    @if (this.upcomingHoles.length > 0) {
      <button class="btn" (click)="nextHole()">
        {{getHoleNumber('holeNumber', upcomingHoles[0].hole.HoleNumber)}}
      </button>
    }
  </div>
  <!-- in-playTop -->

  <!-- conversationHead -->
  <div class="conversationHead d-flex justify-content-end">
    <div class="box bg-white">
      <label>{{"Hole" | translate}}</label>
      <h3>{{currentHole.hole.HoleNumber}}</h3>
    </div>
    <div class="box bg-white">
      <label>{{"Par" | translate }}</label>
      <h3>{{currentHole.par || '--'}}</h3>
    </div>
    <div class="box bg-white">
      <label>{{"Center" | translate}}</label>
      <h3>{{centerDistance | number:'1.0-0'}}
      {{customSetting.distance === 'yards' ? ('Y' | translate) : ('M' | translate)}}</h3>
    </div>
  </div>
  <!-- conversationHead -->
</div>

<!-- conversationCont -->
<div class="conversationCont row justify-content-center">
  <div class="col-lg-6">
    <!-- conversationChat -->
    <div class="conversationChat" id="conversationChat">
      @if (isLoading() || loadingCourseData() || loadingMessage()) {
        <div class="course-loading">
          <ng-lottie class="black-animation" [options]="animationOptions"/>
        </div>
      }
      @else {
      <div class="box chatAdmin">
        <!-- <span class="userPrfl"><img [src]="caddyName ? 'assets/images/SpecialCaddy.jpg' : user.caddy.imageUrl" alt=""></span> -->
        <div class="txtBlck">
          <!-- <h6>{{caddyName ? caddyName : user.caddy.name}}</h6> -->
          <!-- @if(caddyName){
          <p>{{translateOnCourseAdvice1("UnlockCaddieOnCourseAdvice1")}}</p>
          <p>{{"UnlockCaddieOnCourseAdvice2" | translate}}</p>
        }
        @else {  -->
        <p>{{translateOnCourseAdvice1("OnCourseAdvice1")}}</p>
        <!-- } -->
        <p>{{"OnCourseAdvice2" | translate}}</p>
        <p>{{"OnCourseAdvice3" | translate}}</p>
        <p>{{"OnCourseAdvice4" | translate}}</p>
        <p>{{"OnCourseAdvice5" | translate}}</p>
      </div>
    </div>
    @for(conversation of conversations; track $index){
      <div class="box d-flex align-items-center justify-content-end mb-3">
        <!-- <span class="userPrfl">
        <img *ngIf="user.imageUrl" [src]="user.imageUrl" alt="">
        <div class="profile-letter" *ngIf="!user.imageUrl">{{user.name.substring(0, 2).toUpperCase()}}</div>
      </span> -->
      <div class="txtBlck color_box">
        <!-- <h6>You</h6> -->
        <p [innerHTML]="conversation.question | formatChat"></p>
      </div>
    </div>
    <div class="box chatAdmin">
      <!-- <span class="userPrfl"><img [src]="caddyName ? 'assets/images/GALogo.jpg' : user.caddy.imageUrl" alt=""></span> -->
      @if(conversation.loading) {
        <img src="/assets/images/chat-animation.gif" alt="processing">
      }
      <div class="txtBlck">
        <div [innerHTML]="conversation.answer | formatChat"></div>
        @if(conversation.answer)
          {
          <div class="actionBlock mt-2">
            <li (click)="addReaction('dislike', $index, conversation.id)">
              @if (conversation.reaction === 'dislike'){
                <img ngSrc="assets/images/disliked.svg" alt="Dislike" width="18" height="18">
              } @else {
                <img ngSrc="assets/images/dislike.svg" alt="Dislike" width="18" height="16">
              }
            </li>
            <li (click)="addReaction('like', $index, conversation.id)">
              @if (conversation.reaction === 'like'){
                <img ngSrc="assets/images/liked.svg" alt="Like" width="18" height="18">
              } @else {
                <img ngSrc="assets/images/like.svg" alt="Like" width="18" height="16">
              }
            </li>
            <li>
              <a class="cursor-pointer"
                (click)="hearAnswer(conversation.answer, $index)">
                @if (audioAnswerLoading() && playingIndex === $index){
                  <img class="voice-icon" src="assets/images/send-loader.svg" alt="">
                } @else {
                  @if (!answerListening() || playingIndex !== $index) {
                    <img ngSrc="assets/images/sound.svg" alt="" width="18" height="16">
                  }
                  @if (answerListening() && playingIndex === $index) {
                    <img ngSrc="assets/images/stop.svg"
                      alt="" class="stop" width="24" height="24">
                  }
                }
                <!--
                <ng-container *ngIf="audioAnswerLoading && playingIndex === $index; else checkPlaying">
                  <img src="assets/images/send-loader.svg" alt="Loading">
                </ng-container>

                <ng-template #checkPlaying>
                  <img *ngIf="answerListening && playingIndex === $index; else playIcon"
                    src="assets/images/stop.svg"
                    alt="Stop"
                    class="stop">
                  </ng-template>

                  <ng-template #playIcon>
                    <img src="assets/images/sound.svg" alt="Play">
                  </ng-template> -->

                </a>
              </li>
            </div>
            @if(conversation.route === 'rules'){
              <div class="route-block">
                <span>Ask a real rules official</span>
                <a href="javascript:void(0)" (click)="openRuleAssistModal(ruleAssistModal, $index)">
                  <img ngSrc="assets/images/ask-blakey-icon.svg" alt="" width="24" height="24">
                  {{'Ask Blakey' | translate}}
                </a>
              </div>
            }
          }
        </div>
      </div>
    }
  }
</div>
<!-- conversationChat -->
</div>
</div>
<!-- conversationCont -->

<!-- bottomBlock -->
<div class="d-block bottomBlock">
  <div class="voice-block position-relative" [class.disabled]="submitting()">

    <div class="d-flex align-items-center justify-content-between bg-white position-relative w-100 inputBlockBg" [class.inputBlockBg]="isVoiceToVoiceChat() || showTextQuestionControl()">
      <div class="equalizer-box col" [class.active]="showEqualizer()">
        <canvas #equalizerCanvas width="330" height="50"></canvas>
      </div>

      <div class="chat-text-block" [class.active]="showTextQuestionControl() && !isVoiceToVoiceChat()">
        <textarea #myInput name="chatPrompt" [disabled]="submitting()" [(ngModel)]="manualTextQuestion"
          (input)="autoResize($event)" (keydown.enter)="sendManualTextQuestion()"
          (blur)="hideTextQuestionControl()" (focus)="scrollInputIntoView(); showTextQuestionControl.set(true)" placeholder="Ask anything about golf">
        </textarea>

      </div>
      @if(showTextQuestionControl() && !isVoiceToVoiceChat()){
        <button class="btn bg-dark p-0 ms-2 border-0" [disabled]="submitting()" (click)="sendManualTextQuestion()">
          <img ngSrc="assets/images/upArw-voice.svg" alt="Enter" style="max-width: 13px;" width="18" height="22">
        </button>
      }
      @if(isVoiceToVoiceChat()){
        @if(recordingFinished()){
          <div class="audio-wrap">
            <audio #audioRef [src]="audioUrl" (pause)="onPauseOrEnd()" (ended)="onPauseOrEnd()" (play)="onAudioPlay()"></audio>
            <!-- <button [disabled]="submitting()" class="btn bg-white p-0 play-btn" [disabled]="!recordingFinished || !audioUrl"
            (click)="isAudioPlaying ? onPause() : onPlay()">
            <img [src]="isAudioPlaying ? '/assets/images/pause.svg' : '/assets/images/play.svg'"
              [alt]="isAudioPlaying ? 'Pause' : 'Play'">
            </button> -->
          </div>
        }

        <!-- @if (isRecording()) {
        <button (click)="stopRecording()" class="btn bg-white p-0 ms-2">
          <img src="/assets/images/stop.svg" alt="Stop">
        </button> -->
        @if (isRecording()) {
          <button (click)="closeRecording()" class="btn bg-white p-0 ms-2">
            <img ngSrc="assets/images/close.svg" alt="Stop" width="24" height="24">
          </button>
          <button (click)="stopRecording()" class="btn bg-white p-0 ms-2">
            <img ngSrc="assets/images/tick-thin.svg" alt="Close" width="24" height="24">
          </button>
        } @else if (submittingAudio()) {
          <button class="btn bg-white p-0 ms-2">
            <img src="/assets/images/spinner.svg" alt="Close" class="spinning-animation">
          </button>
        }
        @if(submitting()){
          <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer">
            <img src="assets/images/white-loader.svg" alt="">
          </button>
        }
        <!-- @else {
        <button [disabled]="submitting()" (click)="closeRecording()" class="btn bg-white p-0 ms-2">
          <img src="/assets/images/close.svg" alt="Close">
        </button>
        } -->
        @if(audioBlob && !isRecording() && !submittingAudio()){
          <button [disabled]="submitting()" class="btn bg-dark p-0 ms-2 border-0 cursor-pointer"
            (click)="!submitting() ? submitAudioQuestion() : ''">
            <img ngSrc="assets/images/upArw-voice.svg" alt="Enter" width="18" height="22">
          </button>
        }
      }
      <!-- @else if(showTextQuestionControl){ -->
      <!-- <div class="d-flex align-items-center inputBlockBg bg-white"> -->
      <!-- <input type="text" [(ngModel)]="manualTextQuestion" (focus)="scrollToBottom()"
      (keydown.enter)="sendManualTextQuestion()" (blur)="hideTextQuestionControl()"
      placeholder="Ask anything about golf" #myInput> -->
      <!-- <div class="chat-text-block">
      <textarea #myInput name="chatPrompt" [disabled]="submitting()" [(ngModel)]="manualTextQuestion"
        (input)="autoResize($event)" (keydown.enter)="sendManualTextQuestion()"
      (blur)="hideTextQuestionControl()" (focus)="scrollInputIntoView()" placeholder="Ask anything about golf"></textarea>
    </div>
    <button class="btn bg-dark p-0 ms-2 border-0" [disabled]="submitting()" (click)="sendManualTextQuestion()">
      <img src="/assets/images/upArw-voice.svg" alt="Enter" style="max-width: 13px;">
    </button>
    }  -->

    @else if(!showTextQuestionControl()) {
    <div class="caddieAdvice d-flex align-items-center" [class.active]="isAnimating()" (click)="(!submitting() && !findingLocation) ? callCaddy() :''">
      <img [src]="user().caddy && user().caddy.imageUrl ? user().caddy.imageUrl : 'assets/images/GALogo.jpg'" alt="">
      <div class="d-flex px-1 justify-content-center text-nowrap w-100">
        @if(findingLocation){
          <!-- <img src="assets/images/GeneratingIcon.svg" alt="" class="generateIcon me-1"> -->
          <span>{{"FindingLocation" | translate}}</span>
        }
        @else if(isCallCaddy() && isProcessing() || this.submitting()){
        <img src="assets/images/GeneratingIcon.svg" alt="" class="generateIcon me-1">
        <span>{{"Thinking" | translate}}</span>
      }
      @else {
      <span>Caddie Advice</span>
    }
  </div>
</div>
<div class="d-inline-flex align-items-center">
  <button class="btn bg-white p-0 ms-2" (click)="startRecording()">
    <img ngSrc="assets/images/microphone-voice.svg" alt="Microphone" width="24" height="24">
  </button>
  <button class="btn bg-white p-0 ms-2" (click)="showTextQuestionControlInput()">
    <img ngSrc="assets/images/keyboard.svg" alt="Microphone" width="24" height="24">
  </button>
  <button class="btn bg-white p-0 ms-2" (click)="openSettingModal(roundSettingModal)">
    <img ngSrc="assets/images/settings-icon.svg" alt="Microphone" width="24" height="24">
  </button>
</div>
}
</div>
</div>
</div>
<!-- bottomBlock -->
</div>
<!-- conversationBg -->
<ng-template #changeUnitModal>
  <div class="row">
    <div class="modal-body">
      <div class="close-btn" (click)="changeUnitModalRef?.dismiss()">
        <img ngSrc="assets/images/close_icon.svg" alt="" width="16" height="16">
      </div>
      <div class="social-title">
        {{"YardsOrMeters" | translate}}
      </div>
      <div class="confirm-body">
        {{"SelectUnit" | translate}}
      </div>

    </div>
    <div class="confirm-footer">
      <button type="button" class="btn custom-button"
        [ngStyle]="{'background-color': customSetting.distance === 'yards' ? 'green' : 'lightgray'}"
      (click)="changeUnit('yards')">{{"Yards" | translate}}</button>
      <button type="button" class="btn custom-button"
        [ngStyle]="{'background-color': customSetting.distance === 'meters' ? 'green' : 'lightgray'}"
      (click)="changeUnit('meters')">{{"Meters" | translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #roundSettingModal>
  <div class="modal-body text-start">
    <div class="d-flex justify-content-end">
      <a class="cursor-pointer" (click)="closeSettingsModal()">
        <img ngSrc="assets/images/close_icon.svg" alt="Close" width="16" height="16">
      </a>
    </div>
    <h4 class="mb-3">{{'RoundSettings' | translate}}</h4>
    <!-- setting box -->
    <div class="settingbox flex-column">
      <drag-scroll class="d-flex">
        <div drag-scroll-item class="card text-center">
          <!-- Icon -->
          <div class="d-flex justify-content-center">
            <div class="icon_bg rounded-circle d-inline-flex align-items-center justify-content-center">
              <img ngSrc="assets/images/voiceIcon.svg" alt="" width="16" height="20">
            </div>
          </div>
          <!-- Title -->
          <h5 class="mt-2">{{'HandsFree' | translate}} {{customSetting.onCourseAudio === 'on' ? ('on' | translate) : ('off' | translate)}}</h5>
          <!-- Toggle Buttons -->
          <div class="btnBg w-100">
            <button class="btn col" [ngClass]="{'active': customSetting.onCourseAudio === 'on'}" (click)="saveSettings()"
            (click)="customSetting.onCourseAudio = 'on'; saveSettings()">{{'on' | translate}}</button>
            <button class="btn col" [ngClass]="{'active': customSetting.onCourseAudio === 'off'}" (click)="saveSettings()"
            (click)="customSetting.onCourseAudio = 'off'; saveSettings()">{{'off' | translate}}</button>
          </div>
          <p class="text-start">
            {{'HandsFreeDesc' | translate}}
          </p>
        </div>
        <div drag-scroll-item class="card text-center">
          <!-- Icon -->
          <div class="d-flex justify-content-center">
            <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center position-relative">
              <img ngSrc="assets/images/competition_icon.svg" alt="" [ngClass]="{'active': customSetting.onCourseMode === 'competition'}" width="24" height="24">
              <img ngSrc="assets/images/social_icon.svg" alt="" [ngClass]="{'active': customSetting.onCourseMode === 'social'}" width="24" height="24">
            </div>
          </div>
          <!-- Title -->
          <h5 class="mt-2">{{customSetting.onCourseMode === 'competition' ? ('Competition' | translate) : ('Social' | translate)}}</h5>
          <!-- Toggle Buttons -->
          <div class="btnBg w-100">
            <button class="btn col" [ngClass]="{'active': customSetting.onCourseMode === 'competition'}"
            (click)="customSetting.onCourseMode = 'competition'; saveSettings()">{{'Competition' | translate}}</button>
            <button class="btn col" [ngClass]="{'active': customSetting.onCourseMode === 'social'}"
            (click)="customSetting.onCourseMode = 'social'; saveSettings()">{{'Social' | translate}}</button>
          </div>
          <p class="text-start">
            {{'OnCourseModeDesc' | translate}}
          </p>
        </div>
        <div drag-scroll-item class="card text-center">
          <!-- Icon -->
          <div class="d-flex justify-content-center">
            <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center">
              <img ngSrc="assets/images/units_icon.svg" alt="" width="24" height="24">
            </div>
          </div>
          <!-- Title -->
          <h5 class="mt-2">{{'Units' | translate}} {{customSetting.distance === 'meters' ? ('Meters' | translate) : ('Yards' | translate)}}</h5>
          <!-- Toggle Buttons -->
          <div class="btnBg w-100">
            <button class="btn col" [ngClass]="{'active': customSetting.distance === 'yards'}"
            (click)="changeUnit('yards')">{{'Yards' | translate}}</button>
            <button class="btn col" [ngClass]="{'active': customSetting.distance === 'meters'}"
            (click)="changeUnit('meters')">{{'Meters' | translate}}</button>
          </div>
          <p class="text-start">
            {{'DistanceDesc' | translate}}
          </p>
        </div>
      </drag-scroll>
    </div>
    <!-- setting box -->
  </div>
</ng-template>
<ng-template #ruleAssistModal>
  <app-rule-assist-modal [ruleAssistQuestionObject]="ruleAssistQuestionObject"
  (closeModal)="closeRuleAssistModal()"></app-rule-assist-modal>
</ng-template>